import {useDebugValue} from 'react';

function useEdapProvider(searchFormContext) {
    const {
        edap: {
            options: {
                delayProcessing,
                searchSubmitEventName,
                searchSubmitEventActionLocation,
                datedSearchSubmitEventName,
                searchQuerySubmittedEventName,
                searchQuerySubmittedEventActionLocation
            }
        }
    } = searchFormContext;

    const fields = {};

    const options = {
        delayProcessing
    };

    const eventFields = {
        [searchSubmitEventName]: {
            actionlocation: searchSubmitEventActionLocation
        },
        [datedSearchSubmitEventName]: {
            actionlocation: searchSubmitEventActionLocation
        },
        [searchQuerySubmittedEventName]: {
            action_location: searchQuerySubmittedEventActionLocation
        }
    };

    const eventOptions = {};

    const result = {
        fields,
        options,
        eventFields,
        eventOptions
    };

    useDebugValue(result);

    return result;
}

export {useEdapProvider};
